const httpLib = require('./http-library.js');
const publicConfig = require('../public-config.js');

const bundleHost = publicConfig.external_address;

// private

function _readBundles (path, token, callback) {
  const params = {
    host: bundleHost,
    method: 'GET',
    path: `/v1/bundles/${path}`,
    headers: {
      Authorization: `Bearer ${token}`
    }
  };
  httpLib.request(params, function (res) {
    callback(res);
  });
}

// public

const Bundles = {

  /**
   *
   * @function
   * @name inquire
   * @param {String}   - Path string
   * @param {String}   - Access token (retrived from sessions)
   * @param {Function} - Callback
   */

  read: (path, token, callback) => {
    const readBundles = _readBundles(path, token, callback);
    return readBundles;
  }
};

module.exports = Bundles;
